module.exports = __webpack_public_path__ + "img/system-noice.8c89b7f4.gif";